import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import "./modifyCheck.css";

const ModifyCheckTime = (props) => {
  const { updateValue, isDisabled, modifyTime, label, name, defaultRefDate,minTime,maxTime } = props;
  // const defaultDate = new Date(defaultRefDate)
  // const minTime = new Date(defaultDate.setDate(defaultDate.getDate() -1))
  // minTime.setHours(0);
  // minTime.setMinutes(0);
  // minTime.setSeconds(0);
  // minTime.setMilliseconds(0);
  // const maxTime = new Date(defaultRefDate)
  // maxTime.setHours(47);
  // maxTime.setMinutes(59);
  // maxTime.setSeconds(59);
  // maxTime.setMilliseconds(999);
  console.log({minTime,maxTime});
  return (
    <div className="modify-checkintime mb-4">
      <label htmlFor={label} className="form-label">
        {label}
      </label>
      <DateTimePicker
        disabled={isDisabled}
        max={maxTime}
        min={minTime}
        name={name}
        value={new Date(modifyTime)}
        onChange={(e) => updateValue(e.target)}
        format="hh:mm a"
      />
    </div>
  );
};

export default ModifyCheckTime;
